import React, { createContext, useContext, useEffect, useState } from 'react'
import { useAuth } from 'context/auth'
import { useErrorHandling } from 'context/errorHandling'
import { fetchLoggedUserGroupMemberships } from 'services/GroupsService'
import { MAIN } from 'components/Groups/GroupsForm/MembershipType'

const GroupContext = createContext({
  isInMainGroup: () => false,
  hasMainGroupById: () => false
})

export const UserGroupsProvider = ({ children }) => {
  const [userGroups, setUserGroups] = useState(null)

  const { authTokens } = useAuth()
  const { handleError } = useErrorHandling()

  const isInMainGroup = () => {
    return userGroups
      ?.find(group => group.membershipType === MAIN) !== undefined
  }

  const hasMainGroupById = (expectedGroupId) => {
    return userGroups
      ?.filter(group => group.membershipType === MAIN)
      ?.map(group => group.groupId)
      ?.includes(expectedGroupId)
  }

  useEffect(() => {
    if (authTokens) {
      fetchLoggedUserGroupMemberships()
        .then(setUserGroups)
        .catch(handleError)
    } else {
      setUserGroups(null)
    }
  }, [authTokens, handleError])

  return <GroupContext.Provider value={{
    isInMainGroup,
    hasMainGroupById
  }}>
    {children}
  </GroupContext.Provider>
}

export function useUserGroups () {
  return useContext(GroupContext)
}
